// extracted by mini-css-extract-plugin
export default {"fallbackContainer":"SuspenseWithFlag_fallbackContainer__e+LCr","childrenContainer":"SuspenseWithFlag_childrenContainer__jRyYK"};